module.exports = __webpack_public_path__ + "img/Logo Search_Talmud_Blue_Circle.bc1da23a.png";